import { render, staticRenderFns } from "./GetCustomerEconomicInfo.vue?vue&type=template&id=f5b64360&scoped=true&"
import script from "./GetCustomerEconomicInfo.vue?vue&type=script&lang=js&"
export * from "./GetCustomerEconomicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b64360",
  null
  
)

export default component.exports